import React, { useState } from 'react';
import Badge from './badge';

const ImageList = ({ list }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const sorted = list.sort((a, b) => a.order - b.order);
  const current = sorted[currentIndex];

  if (!current) return null;

  return (
    <div className='detail-image-list'>
      <img
        src={current.url}
        alt={`Imagem ${currentIndex + 1} de ${sorted.length}`}
        className='detail-image-list__image'
      />

      <div className='detail-image-list__controls'>
        <button
          className='detail-image-list__arrow'
          onClick={() => setCurrentIndex((currentIndex - 1 + sorted.length) % sorted.length)}
          title='Imagem anterior'
        >
          ←
        </button>

        <div className='detail-image-list__badges'>
          <Badge text={`${currentIndex + 1} de ${sorted.length}`} />
          {current.website && (<Badge text='Publicado no site' />)}
          {current.highlight && (<Badge text='Principal' />)}
        </div>

        <button
          className='detail-image-list__arrow'
          onClick={() => setCurrentIndex((currentIndex + 1) % sorted.length)}
          title='Próxima imagem'
        >
          →
        </button>
      </div>
    </div>
  )
}

export default ImageList;
